module.exports = __webpack_public_path__ + "img/1-200430154QR25.4b5a1de4.jpeg";